import { ConfigurableQuestionnaireKey, questionnaireTypes } from "@teamprevent/common/questionnaires/questionnaireConfig/models";
import { keys } from "lodash";
import * as React from "react";
import { connect } from "react-redux";

import { Grid, Header, Table } from "semantic-ui-react";

import { ApplicationState } from "../../applicationState";

import { Link } from "redux-little-router";

interface Props {
    path: string;
}

const AllUnconnected: React.FunctionComponent<Props> = (props: Props) => (
    <Grid container className="nomargintop">
        <Grid.Row>
            <Grid.Column>
                <Header as="h1" content="Form Customisation" />
            </Grid.Column>
        </Grid.Row>
        <Grid.Row>
            <Grid.Column>
                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>
                                Form
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {(keys(questionnaireTypes) as ConfigurableQuestionnaireKey[]).map(questionnaireType =>
                            (<Table.Row key={questionnaireType}>
                                <Table.Cell>
                                    <Link href={`${props.path}/${questionnaireType}`}>{questionnaireTypes[questionnaireType].displayName}</Link>
                                </Table.Cell>
                            </Table.Row>)
                        )}
                    </Table.Body>
                </Table>
            </Grid.Column>
        </Grid.Row>
    </Grid>
);

const mapStateToProps = (state: ApplicationState): Props => ({
    path: state.router.pathname
});

export const All = connect(mapStateToProps)(AllUnconnected);
